/* CYGNUSS 01/11/2026: popup de e-mail da Klaviyo sem desenho no iPhone com iOS 16 (Guifa, iPhone X 16.7).
   A Klaviyo poe o CSS do bloco de codigo proprio dentro de "@scope { ... }", que o Safari so le a partir do iOS 17.4: no iOS 16 o
   bloco inteiro e ignorado e o popup aparece cru. Aqui, so em navegador sem @scope, cada <style> desses ganha uma copia sem o
   invólucro, com os seletores presos ao popup (.needsclick) para nao pegar nada do tema. Navegador novo nao roda nada. */
(function () {
  if ('CSSScopeRule' in window) return;
  var FEITO = 'data-cyg-sem-scope';

  function semEscopo(css) {
    var corpo = css.replace(/^\s*@scope\s*(\([^)]*\)\s*)?\{/, '').replace(/\}\s*$/, '');
    /* as fontes do popup (@import) viram <link> no <head>, que o Safari carrega mesmo com o estilo inserido depois */
    corpo = corpo.replace(/@import\s+url\(\s*['"]?([^'")]+)['"]?\s*\)\s*;?/g, function (m, url) {
      if (!document.querySelector('link[' + FEITO + '][href="' + url + '"]')) {
        var l = document.createElement('link'); l.rel = 'stylesheet'; l.href = url; l.setAttribute(FEITO, 'fonte');
        document.head.appendChild(l);
      }
      return '';
    });
    corpo = corpo.replace(/\/\*[\s\S]*?\*\//g, '');
    /* regras simples (sem @media dentro, como o CSS deste popup): prende cada seletor ao popup */
    corpo = corpo.replace(/([^{}]+)\{/g, function (m, sel) {
      sel = sel.trim();
      if (!sel || sel.charAt(0) === '@') return m;
      return sel.split(',').map(function (s) { return '.needsclick ' + s.trim(); }).join(',') + '{';
    });
    return corpo;
  }

  function tratar(el) {
    if (el.hasAttribute(FEITO)) return;
    var t = el.textContent || '';
    if (!/^\s*@scope\b/.test(t) || t.indexOf('.cy') < 0) return;
    el.setAttribute(FEITO, '');
    var novo = document.createElement('style');
    novo.setAttribute(FEITO, 'copia');
    novo.textContent = semEscopo(t);
    el.parentNode.insertBefore(novo, el.nextSibling);
  }

  function varrer() { [].forEach.call(document.querySelectorAll('style:not([' + FEITO + '])'), tratar); }
  varrer();
  new MutationObserver(varrer).observe(document.documentElement, { childList: true, subtree: true });
})();
